export default __webpack_public_path__ + "static/media/nutrition.db502210.png";